<template>
    <div>
        <div class="invoice__cards full--width flex">
            <div class="card">
                <p><strong>Current month</strong></p>
                <svg-spinner v-if="isLoading" class="spinner" />
                <h3>
                    <span v-if="hasToken">
                        <strong v-if="hasUsageData && currentMonthUsage && currentMonthUsage.total && currentMonthUsage.total.total">€{{ currentMonthUsage.total.total.toFixed(2) }}</strong>
                        <small v-else-if="hasUsageData">No data</small>
                        <small v-else-if="hasUsageError">No data</small>
                        <small v-else><svg-spinner class="spinner"/></small>
                    </span>
                    <span v-else>€0.00</span>
                </h3>
            </div>
            <div class="card pending">
                <p><strong>Forecasted month end</strong>
                    <i v-b-tooltip.hover class="abbr-tooltip" title="This is a estimation. You cannot extract any rights from this data."><i class="fa fa-info-circle"></i></i>
                </p>
                <svg-spinner v-if="isLoading" class="spinner" />
                <h3 v-else>€<span v-if="invoices[0]">{{  invoices[0].amount_in_cents / 100 }}</span><span v-else>0.00</span></h3>
            </div>
            <div class="card failed">
                <p><strong>Last month</strong></p>
                <svg-spinner v-if="isLoading" class="spinner" />
                <h3 v-else>
                    <span v-if="invoices && invoices[0]">
                        <span v-if="invoices[0].amount_in_cents_ex_vat !== invoices[0].amount_in_cents">
                            <small><strike>€{{ (invoices[0].amount_in_cents / 100).toFixed(2) }}</strike></small>
                        </span> € {{ (invoices[0].amount_in_cents_ex_vat / 100).toFixed(2) }}
                    </span>
                    <span v-else>0.00</span>
                </h3>
                
            </div>
        </div>
        <div class="flex" :class="{'nodata--container': noInvoices}">
            <div class="chart__container" :class="{'nodata': noInvoices}">
                <fChart :responseData='invoices' v-if="!isLoading && !noInvoices"/>
            </div>
            <div class="invoice__cards">
                <div class="card">
                    <h3>Paid</h3>
                    <svg-spinner v-if="isLoading" class="spinner" />
                    <strong v-else>{{  invoices.filter(item => item.status === 'paid').length }}</strong>
                </div>
                <div class="card pending pending--container">
                    <i v-b-tooltip.hover class="abbr-tooltip" title="We will try to collect the money on a later date. Please update your billing details to fix any issues."><i class="fa fa-info-circle"></i></i>
                    <h3>Pending</h3>
                    <svg-spinner v-if="isLoading" class="spinner" />
                    <strong v-else>{{  invoices.filter(item => item.status === 'past_due').length }}</strong>
                </div>
                <div class="card failed">
                    <h3>Failed</h3>
                    <svg-spinner v-if="isLoading" class="spinner" />
                    <strong v-else>{{  invoices.filter(item => item.status === 'failed').length }}</strong>
                </div>
            </div>
            <svg-spinner v-if="isLoading" class="spinner" />
        </div>
    </div>
</template>

<script>
import fChart from '@/components/charts/f-show-chart-invoice';
import { getInvoices } from '@/assets/js/api/invoices';
const svgSpinner = () => import('@/components/svg/svg-spinner');

export default {
    props: ['selectedCustomerId'],

    data() {
        return {
            isLoading: true,
            invoices: [],
            noInvoices: true,
        }
    },

    computed: {
        currentMonthUsage() {
            let data = this.$store.state.usage.currentMonth;
            if (data) {
                this.isLoading = false;
                return data;
            } else {
                this.isLoading = true;
                return false;
            }
        },
    },

    methods: {
        fetchInvoices() {
            getInvoices(this.selectedCustomerId)
            .then((response) => {
                this.isLoading = false;

                // let data = [{"id":3103,"invoice_number":"22701088","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-08-03T10:34:19.409311+00:00","amount_in_cents":11484,"invoice_date":"2022-08-03","status":"paid","attempts":1,"usage_period_end":"2022-07-31","usage_period_start":"2022-07-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":2942,"invoice_number":"22700924","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-07-03T10:01:54.901146+00:00","amount_in_cents":9289,"invoice_date":"2022-07-03","status":"paid","attempts":1,"usage_period_end":"2022-06-30","usage_period_start":"2022-06-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":3790,"invoice_number":"23700029","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-01-03T10:32:13.458467+00:00","amount_in_cents":12242,"invoice_date":"2023-01-03","status":"paid","attempts":1,"usage_period_end":"2022-12-31","usage_period_start":"2022-12-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":47068,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":3238,"invoice_number":"22701227","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-09-03T10:35:41.255999+00:00","amount_in_cents":12888,"invoice_date":"2022-09-03","status":"paid","attempts":1,"usage_period_end":"2022-08-31","usage_period_start":"2022-08-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":2658,"invoice_number":"22700640","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-05-03T10:02:13.701622+00:00","amount_in_cents":8979,"invoice_date":"2022-05-03","status":"paid","attempts":1,"usage_period_end":"2022-04-30","usage_period_start":"2022-04-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":3367,"invoice_number":"22701356","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-10-03T10:35:45.359405+00:00","amount_in_cents":14586,"invoice_date":"2022-10-03","status":"paid","attempts":1,"usage_period_end":"2022-09-30","usage_period_start":"2022-09-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":2803,"invoice_number":"22700785","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-06-03T10:01:56.601578+00:00","amount_in_cents":9597,"invoice_date":"2022-06-03","status":"paid","attempts":1,"usage_period_end":"2022-05-31","usage_period_start":"2022-05-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":3507,"invoice_number":"22701496","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-11-03T11:40:58.896839+00:00","amount_in_cents":16322,"invoice_date":"2022-11-03","status":"paid","attempts":2,"usage_period_end":"2022-10-31","usage_period_start":"2022-10-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":13493,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":3644,"invoice_number":"22701633","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-12-05T13:13:04.277054+00:00","amount_in_cents":0,"invoice_date":"2022-12-05","status":"paid","attempts":0,"usage_period_end":"2022-11-30","usage_period_start":"2022-11-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":27641,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":3951,"invoice_number":"23700189","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-02-03T10:30:21.866+00:00","amount_in_cents":61839,"invoice_date":"2023-02-03","status":"paid","attempts":1,"usage_period_end":"2023-01-31","usage_period_start":"2023-01-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":51106,"paid_at":"2023-02-04","amount_in_cents_ex_vat":null},{"id":4091,"invoice_number":"23700330","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-03-03T14:42:58.332671+00:00","amount_in_cents":70000,"invoice_date":"2023-03-03","status":"paid","attempts":3,"usage_period_end":"2023-02-28","usage_period_start":"2023-02-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":57853,"paid_at":"2023-03-14","amount_in_cents_ex_vat":57849},{"id":4210,"invoice_number":"23700456","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-04-03T10:23:09.768059+00:00","amount_in_cents":95516,"invoice_date":"2023-04-03","status":"paid","attempts":1,"usage_period_end":"2023-03-31","usage_period_start":"2023-03-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":78953,"paid_at":"2023-04-04","amount_in_cents_ex_vat":78939},{"id":5041,"invoice_number":"23701301","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-11-03T10:23:34.514192+00:00","amount_in_cents":133400,"invoice_date":"2023-11-03","status":"paid","attempts":1,"usage_period_end":"2023-10-31","usage_period_start":"2023-10-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":110265,"paid_at":"2023-11-04","amount_in_cents_ex_vat":110248},{"id":4328,"invoice_number":"23700576","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-05-03T10:23:30.403061+00:00","amount_in_cents":102377,"invoice_date":"2023-05-03","status":"paid","attempts":1,"usage_period_end":"2023-04-30","usage_period_start":"2023-04-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":84621,"paid_at":"2023-05-04","amount_in_cents_ex_vat":84607},{"id":4443,"invoice_number":"23700701","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-06-03T10:23:31.444279+00:00","amount_in_cents":94196,"invoice_date":"2023-06-03","status":"paid","attempts":1,"usage_period_end":"2023-05-31","usage_period_start":"2023-05-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":77865,"paid_at":"2023-06-04","amount_in_cents_ex_vat":77849},{"id":4562,"invoice_number":"23700821","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-07-03T11:53:08.02821+00:00","amount_in_cents":92803,"invoice_date":"2023-07-03","status":"paid","attempts":1,"usage_period_end":"2023-06-30","usage_period_start":"2023-06-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":76713,"paid_at":"2023-07-04","amount_in_cents_ex_vat":76697},{"id":4682,"invoice_number":"23700941","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-08-03T10:22:43.033247+00:00","amount_in_cents":89614,"invoice_date":"2023-08-03","status":"paid","attempts":1,"usage_period_end":"2023-07-31","usage_period_start":"2023-07-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":74078,"paid_at":"2023-08-04","amount_in_cents_ex_vat":74062},{"id":4785,"invoice_number":"23701045","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-09-03T10:23:27.058791+00:00","amount_in_cents":93029,"invoice_date":"2023-09-03","status":"paid","attempts":1,"usage_period_end":"2023-08-31","usage_period_start":"2023-08-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":76896,"paid_at":"2023-09-04","amount_in_cents_ex_vat":76883},{"id":4920,"invoice_number":"23701179","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2023-10-03T10:23:20.497028+00:00","amount_in_cents":295908,"invoice_date":"2023-10-03","status":"paid","attempts":1,"usage_period_end":"2023-09-30","usage_period_start":"2023-09-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":79277,"paid_at":"2023-10-04","amount_in_cents_ex_vat":79262}]
                // data = []

                // data = [{"id":3103,"invoice_number":"22701088","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-08-03T10:34:19.409311+00:00","amount_in_cents":11484,"invoice_date":"2022-08-03","status":"paid","attempts":1,"usage_period_end":"2022-07-31","usage_period_start":"2022-07-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null},{"id":2942,"invoice_number":"22700924","customer_id":"2e5fcf51-8ba2-4ab8-ab47-a7c29ef9753e","created_at":"2022-07-03T10:01:54.901146+00:00","amount_in_cents":91111232289,"invoice_date":"2022-07-03","status":"paid","attempts":1,"usage_period_end":"2022-06-30","usage_period_start":"2022-06-01","payment_link":null,"payment_link_expiry":null,"amount_without_discount_in_cents":null,"paid_at":null,"amount_in_cents_ex_vat":null}]

                // let sortedData = data.sort((a, b) => {
                let sortedData = response.data.sort((a, b) => {
                    return new Date(a.invoice_date).getTime() - new Date(b.invoice_date).getTime()
                });
                this.invoices = sortedData;
                if (this.invoices.length > 1) {
                    this.noInvoices = false;
                }
            })
            .catch((error) => {
                this.showNotification('error', `Fetching your invoices has failed`);
                console.error(error);
                this.isLoading = false;
            });
        },
    },

    mounted() {
        this.fetchInvoices();
    },

    components: {
        fChart,
        svgSpinner,
    }
}
</script>
<style scoped="scoped">
.chart__container {
    width: 80%;
}
.chart__container.nodata {
    height: 400px;
    background: #dde4e7;
    display: none;
}
.nodata--container {
    display: block;
}
.nodata--container > .invoice__cards {
    display: flex;
    width: 100%;
    padding: 0;
}
.nodata--container > .invoice__cards .card {
    flex-basis: 33%;
}
.invoice__cards {
    width: 20%;
    position: relative;
    padding: 0 0 0 20px;
}
.invoice__cards.full--width .card {
    flex-basis: 33%;
}
.invoice__cards .card {
    padding: 30px 30px 30px 40px;
}
.invoice__cards h3:before {
    content: '';
    height: calc(100% - 40px);
    width: 2px;
    background: #008000;
    position: absolute;
    left: 20px;
    top: 20px;
}
.invoice__cards .failed h3:before {
    background: #c00;
}
.invoice__cards .pending h3:before {
    background: #ff8f00;
}
.invoice__cards.full--width {
  width: 100%;
  padding: 0;
}
.invoice__cards.full--width h3:before {
    background: #25b3b8
}
h3 small {
    font-size: 60%;
}
.pending--container .abbr-tooltip {
    margin: 0 0 -20px auto;
}
</style>